import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';

/**
 * Shared "Services Performed Today" checkbox list used by Crew Mode
 * clock-in/out and the summer job log. Parents render bold; contracted
 * sub-services indent underneath.
 */
const ContractedServicesChecklist = ({
  items = [],
  values = {},
  onToggle,
  title,
  helper,
  emptyMessage,
}) => {
  if (!items.length) {
    if (!emptyMessage) return null;
    return (
      <Typography color="text.secondary">
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Box>
      {title ? (
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
          {title}
        </Typography>
      ) : null}
      {helper ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
          {helper}
        </Typography>
      ) : null}
      <FormGroup>
        {items.map((item) => (
          <FormControlLabel
            key={item.key}
            control={(
              <Checkbox
                checked={!!values[item.key]}
                onChange={() => onToggle(item.key)}
                size="large"
                inputProps={{ 'aria-label': item.label }}
              />
            )}
            label={(
              <Typography
                variant="body1"
                sx={{
                  fontWeight: item.type === 'service' ? 600 : 'normal',
                  color: item.type === 'service' ? 'primary.main' : 'text.secondary',
                  fontSize: item.type === 'sub' ? '0.95rem' : '1rem',
                }}
              >
                {item.label}
              </Typography>
            )}
            sx={{
              mb: 1,
              ml: item.type === 'sub' ? 3 : 0,
              display: 'flex',
            }}
          />
        ))}
      </FormGroup>
    </Box>
  );
};

export default ContractedServicesChecklist;
